import React, { useEffect, useState } from 'react';
import { BankAccountForm } from './BankAccountForm';
import { ChevronRightIcon, CreditCardIcon, PlusIcon, SearchIcon, FilterIcon, EditIcon, EyeIcon, TrashIcon, CheckIcon, BuildingIcon, UsersIcon, BriefcaseIcon, MapPinIcon, ChevronLeftIcon, XIcon } from 'lucide-react';
export function BankAccountsManagement({
  locale
}) {
  const [view, setView] = useState('list');
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [viewingAccount, setViewingAccount] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [bankAccounts, setBankAccounts] = useState([
  // Org Unit Bank Accounts
  {
    id: 'ba-001',
    bankName: 'Chase Bank',
    accountName: 'Operating Account',
    accountNumber: '1234567890',
    routingNumber: '021000021',
    swiftCode: 'CHASUS33',
    iban: '',
    currency: 'USD',
    branchName: 'New York Main',
    accountType: 'Checking',
    country: 'US',
    isPrimary: true,
    association: {
      type: 'Org Unit',
      name: 'New York Headquarters',
      id: 'org-002'
    }
  }, {
    id: 'ba-002',
    bankName: 'Barclays',
    accountName: 'European Operations',
    accountNumber: '9876543210',
    routingNumber: '20-00-00',
    swiftCode: 'BARCGB22',
    iban: 'GB29BARC20000098765432',
    currency: 'GBP',
    branchName: 'London City',
    accountType: 'Business',
    country: 'GB',
    isPrimary: false,
    association: {
      type: 'Org Unit',
      name: 'European Operations Ltd',
      id: 'org-004'
    }
  }, {
    id: 'ba-003',
    bankName: 'Commonwealth Bank',
    accountName: 'APAC Operations',
    accountNumber: '5555666677',
    routingNumber: '062-000',
    swiftCode: 'CTBAAU2S',
    iban: '',
    currency: 'AUD',
    branchName: 'Sydney CBD',
    accountType: 'Business',
    country: 'AU',
    isPrimary: true,
    association: {
      type: 'Org Unit',
      name: 'Sydney Office',
      id: 'org-007'
    }
  },
  // Vendor Bank Accounts
  {
    id: 'ba-004',
    bankName: 'Bank of America',
    accountName: 'Vendor Payments',
    accountNumber: '1111222233',
    routingNumber: '026009593',
    swiftCode: 'BOFAUS3N',
    iban: '',
    currency: 'USD',
    branchName: 'San Francisco',
    accountType: 'Checking',
    country: 'US',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Dell Technologies',
      id: 'vendor-002'
    }
  }, {
    id: 'ba-005',
    bankName: 'Chase Bank',
    accountName: 'Office Depot Operating',
    accountNumber: '9988776655',
    routingNumber: '021000021',
    swiftCode: 'CHASUS33',
    iban: '',
    currency: 'USD',
    branchName: 'Chicago Branch',
    accountType: 'Business',
    country: 'US',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Office Depot',
      id: 'vendor-001'
    }
  }, {
    id: 'ba-006',
    bankName: 'TD Canada Trust',
    accountName: 'PrintWorks Business',
    accountNumber: '4444555566',
    routingNumber: '004',
    swiftCode: 'TDOMCATTTOR',
    iban: '',
    currency: 'CAD',
    branchName: 'Toronto Main',
    accountType: 'Business',
    country: 'CA',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'PrintWorks Inc.',
      id: 'vendor-003'
    }
  }, {
    id: 'ba-007',
    bankName: 'Wells Fargo',
    accountName: 'Acme Construction',
    accountNumber: '7777888899',
    routingNumber: '121000248',
    swiftCode: 'WFBIUS6S',
    iban: '',
    currency: 'USD',
    branchName: 'Los Angeles',
    accountType: 'Business',
    country: 'US',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Acme Construction',
      id: 'vendor-004'
    }
  }, {
    id: 'ba-008',
    bankName: 'Mizuho Bank',
    accountName: 'Pacific Manufacturing',
    accountNumber: '3333444455',
    routingNumber: '',
    swiftCode: 'MHCBJPJT',
    iban: '',
    currency: 'JPY',
    branchName: 'Tokyo Branch',
    accountType: 'Business',
    country: 'JP',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Pacific Manufacturing',
      id: 'vendor-008'
    }
  }, {
    id: 'ba-009',
    bankName: 'Deutsche Bank',
    accountName: 'TechSupply Operations',
    accountNumber: '6666777788',
    routingNumber: '',
    swiftCode: 'DEUTDEFF',
    iban: 'DE89370400440532013000',
    currency: 'EUR',
    branchName: 'Frankfurt',
    accountType: 'Business',
    country: 'DE',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'TechSupply Co.',
      id: 'vendor-006'
    }
  }, {
    id: 'ba-010',
    bankName: 'HSBC',
    accountName: 'Global Logistics',
    accountNumber: '2222333344',
    routingNumber: '40-00-00',
    swiftCode: 'HBUKGB4B',
    iban: 'GB82HBUK40000022223333',
    currency: 'GBP',
    branchName: 'London',
    accountType: 'Business',
    country: 'GB',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Global Logistics Partners',
      id: 'vendor-005'
    }
  }, {
    id: 'ba-011',
    bankName: 'US Bank',
    accountName: 'Green Energy',
    accountNumber: '8888999900',
    routingNumber: '123000220',
    swiftCode: 'USBKUS44',
    iban: '',
    currency: 'USD',
    branchName: 'Portland',
    accountType: 'Business',
    country: 'US',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Green Energy Solutions',
      id: 'vendor-007'
    }
  }, {
    id: 'ba-012',
    bankName: 'Citibank',
    accountName: 'Metro Cleaning',
    accountNumber: '5555444433',
    routingNumber: '021000089',
    swiftCode: 'CITIUS33',
    iban: '',
    currency: 'USD',
    branchName: 'New York',
    accountType: 'Business',
    country: 'US',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Metro Cleaning Services',
      id: 'vendor-009'
    }
  }, {
    id: 'ba-013',
    bankName: 'Wells Fargo',
    accountName: 'Elite Consulting',
    accountNumber: '1122334455',
    routingNumber: '121000248',
    swiftCode: 'WFBIUS6S',
    iban: '',
    currency: 'USD',
    branchName: 'San Francisco',
    accountType: 'Business',
    country: 'US',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Elite Consulting Group',
      id: 'vendor-010'
    }
  }, {
    id: 'ba-014',
    bankName: 'Royal Bank of Canada',
    accountName: 'Northern Supplies',
    accountNumber: '6677889900',
    routingNumber: '003',
    swiftCode: 'ROYCCAT2',
    iban: '',
    currency: 'CAD',
    branchName: 'Toronto',
    accountType: 'Business',
    country: 'CA',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Northern Supplies Ltd',
      id: 'vendor-011'
    }
  }, {
    id: 'ba-015',
    bankName: 'Bank of America',
    accountName: 'Apex Security',
    accountNumber: '9900112233',
    routingNumber: '026009593',
    swiftCode: 'BOFAUS3N',
    iban: '',
    currency: 'USD',
    branchName: 'Los Angeles',
    accountType: 'Business',
    country: 'US',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Apex Security Systems',
      id: 'vendor-012'
    }
  }, {
    id: 'ba-016',
    bankName: 'BNP Paribas',
    accountName: 'Continental Foods',
    accountNumber: '4455667788',
    routingNumber: '',
    swiftCode: 'BNPAFRPP',
    iban: 'FR7630006000011234567890189',
    currency: 'EUR',
    branchName: 'Paris',
    accountType: 'Business',
    country: 'FR',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Continental Foods',
      id: 'vendor-013'
    }
  }, {
    id: 'ba-017',
    bankName: 'Lloyds Bank',
    accountName: 'Digital Marketing',
    accountNumber: '7788990011',
    routingNumber: '30-00-00',
    swiftCode: 'LOYDGB21',
    iban: 'GB29LOYD30000077889900',
    currency: 'GBP',
    branchName: 'Manchester',
    accountType: 'Business',
    country: 'GB',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Digital Marketing Pro',
      id: 'vendor-014'
    }
  }, {
    id: 'ba-018',
    bankName: 'Chase Bank',
    accountName: 'Industrial Parts',
    accountNumber: '2233445566',
    routingNumber: '021000021',
    swiftCode: 'CHASUS33',
    iban: '',
    currency: 'USD',
    branchName: 'Los Angeles',
    accountType: 'Business',
    country: 'US',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Industrial Parts Warehouse',
      id: 'vendor-015'
    }
  }, {
    id: 'ba-019',
    bankName: 'TD Bank',
    accountName: 'Swift Transportation',
    accountNumber: '5566778899',
    routingNumber: '031101266',
    swiftCode: 'NRTHUS33',
    iban: '',
    currency: 'USD',
    branchName: 'New York',
    accountType: 'Business',
    country: 'US',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Swift Transportation',
      id: 'vendor-016'
    }
  }, {
    id: 'ba-020',
    bankName: 'UniCredit',
    accountName: 'Premium Furniture',
    accountNumber: '8899001122',
    routingNumber: '',
    swiftCode: 'UNCRITMM',
    iban: 'IT60X0542811101000000123456',
    currency: 'EUR',
    branchName: 'Milan',
    accountType: 'Business',
    country: 'IT',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Premium Office Furniture',
      id: 'vendor-017'
    }
  }, {
    id: 'ba-021',
    bankName: 'JPMorgan Chase',
    accountName: 'CloudTech',
    accountNumber: '3344556677',
    routingNumber: '021000021',
    swiftCode: 'CHASUS33',
    iban: '',
    currency: 'USD',
    branchName: 'New York',
    accountType: 'Business',
    country: 'US',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'CloudTech Solutions',
      id: 'vendor-018'
    }
  }, {
    id: 'ba-022',
    bankName: 'First Hawaiian Bank',
    accountName: 'Reliable Maintenance',
    accountNumber: '6677889911',
    routingNumber: '121301028',
    swiftCode: 'FHBKUS77',
    iban: '',
    currency: 'USD',
    branchName: 'Honolulu',
    accountType: 'Business',
    country: 'US',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Reliable Maintenance Co.',
      id: 'vendor-019'
    }
  }, {
    id: 'ba-023',
    bankName: 'Bank of China',
    accountName: 'Global Trade',
    accountNumber: '9988776655',
    routingNumber: '',
    swiftCode: 'BKCHCNBJ',
    iban: '',
    currency: 'CNY',
    branchName: 'Beijing',
    accountType: 'Business',
    country: 'CN',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Global Trade Partners',
      id: 'vendor-020'
    }
  }]);
  const filteredAccounts = bankAccounts.filter(account => {
    const matchesSearch = account.bankName.toLowerCase().includes(searchTerm.toLowerCase()) || account.accountName.toLowerCase().includes(searchTerm.toLowerCase()) || account.currency.toLowerCase().includes(searchTerm.toLowerCase()) || account.accountType.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = filterType === 'All' || account.association && account.association.type === filterType;
    return matchesSearch && matchesType;
  });
  // Pagination calculations
  const totalItems = filteredAccounts.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedAccounts = filteredAccounts.slice(startIndex, endIndex);
  // Reset to page 1 when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterType]);
  const handlePageChange = page => {
    setCurrentPage(page);
  };
  const handleEdit = (account, e) => {
    if (e) e.stopPropagation();
    setSelectedAccount(account);
    setView('form');
  };
  const handleView = (account, e) => {
    if (e) e.stopPropagation();
    setViewingAccount(account);
  };
  const handleCreate = () => {
    setSelectedAccount(null);
    setView('form');
  };
  const handleDelete = id => {
    if (window.confirm('Are you sure you want to delete this bank account?')) {
      setBankAccounts(bankAccounts.filter(acc => acc.id !== id));
    }
  };
  const handleSave = accountData => {
    if (accountData.id) {
      // Update existing account
      setBankAccounts(bankAccounts.map(acc => {
        if (acc.id === accountData.id) {
          return {
            ...accountData,
            association: acc.association
          };
        }
        // If this one is set to primary, unset others
        if (accountData.isPrimary) {
          return {
            ...acc,
            isPrimary: false
          };
        }
        return acc;
      }));
    } else {
      // Create new account
      const newAccount = {
        ...accountData,
        id: `ba-${Date.now()}`,
        association: null
      };
      let updatedAccounts = [...bankAccounts];
      // If new account is primary, unset others
      if (newAccount.isPrimary) {
        updatedAccounts = updatedAccounts.map(acc => ({
          ...acc,
          isPrimary: false
        }));
      }
      setBankAccounts([...updatedAccounts, newAccount]);
    }
    setView('list');
  };
  const handleCancel = () => {
    setView('list');
    setSelectedAccount(null);
  };
  const getAssociationIcon = type => {
    switch (type) {
      case 'Vendor':
        return <BriefcaseIcon className="h-3 w-3 mr-1" data-id="element-8417" />;
      case 'Org Unit':
        return <UsersIcon className="h-3 w-3 mr-1" data-id="element-8418" />;
      case 'Contact':
        return <UsersIcon className="h-3 w-3 mr-1" data-id="element-8419" />;
      default:
        return <UsersIcon className="h-3 w-3 mr-1" data-id="element-8420" />;
    }
  };
  const getAssociationColor = type => {
    switch (type) {
      case 'Vendor':
        return 'bg-blue-100 text-blue-800';
      case 'Org Unit':
        return 'bg-orange-100 text-orange-800';
      case 'Contact':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div className="space-y-6" data-id="element-8421">
      <div className="mb-8" data-id="element-8422">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-8423">
          Bank Accounts Management
        </h2>
        <p className="mt-1 text-sm text-gray-500" data-id="element-8424">
          A centralized view of all bank accounts across the organization and
          their associations
        </p>
      </div>

      {view === 'list' && <>
          {/* Filters and Search */}
          <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-8425">
            <div className="relative max-w-xs w-full" data-id="element-8426">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-8427">
                <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" data-id="element-8428" />
              </div>
              <input type="text" className="block w-full rounded-md border-gray-300 pl-10 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" placeholder="Search bank accounts..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-8429" />
            </div>

            <div className="flex items-center gap-2" data-id="element-8430">
              <FilterIcon className="h-5 w-5 text-gray-400" data-id="element-8431" />
              <span className="text-sm text-gray-700" data-id="element-8432">Filter by usage:</span>
              <select className="block rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm" value={filterType} onChange={e => setFilterType(e.target.value)} data-id="element-8433">
                <option value="All" data-id="element-8434">All Associations</option>
                <option value="Vendor" data-id="element-8435">Vendors</option>
                <option value="Org Unit" data-id="element-8436">Org Units</option>
                <option value="Contact" data-id="element-8437">Contacts</option>
              </select>
            </div>
          </div>

          {/* Content */}
          <div className="flex flex-col lg:flex-row gap-8" data-id="element-8438">
            {/* Table */}
            <div className={`flex-1 ${viewingAccount ? 'hidden lg:block lg:w-2/3' : 'w-full'}`} data-id="element-8439">
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" data-id="element-8440">
                <table className="min-w-full divide-y divide-gray-300" data-id="element-8441">
                  <thead className="bg-gray-50" data-id="element-8442">
                    <tr data-id="element-8443">
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6" data-id="element-8444">
                        Bank / Account
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-8445">
                        Account Number
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-8446">
                        Type / Currency
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-8447">
                        Used In
                      </th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6" data-id="element-8448">
                        <span className="sr-only" data-id="element-8449">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white" data-id="element-8450">
                    {paginatedAccounts.length > 0 ? paginatedAccounts.map(account => <tr key={account.id} className={`hover:bg-gray-50 ${viewingAccount?.id === account.id ? 'bg-indigo-50' : ''}`} data-id="element-8451">
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6" data-id="element-8452">
                            <div className="flex items-center" data-id="element-8453">
                              <CreditCardIcon className="h-5 w-5 text-gray-400 mr-3" data-id="element-8454" />
                              <div data-id="element-8455">
                                <div className="font-medium text-gray-900" data-id="element-8456">
                                  {account.bankName}
                                </div>
                                <div className="text-gray-500" data-id="element-8457">
                                  {account.accountName}
                                </div>
                                {account.isPrimary && <span className="inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800 mt-1" data-id="element-8458">
                                    <CheckIcon className="h-3 w-3 mr-1" data-id="element-8459" />
                                    Primary
                                  </span>}
                              </div>
                            </div>
                          </td>
                          <td className="px-3 py-4 text-sm text-gray-500" data-id="element-8460">
                            <div data-id="element-8461">
                              <div className="font-mono" data-id="element-8462">
                                •••• {account.accountNumber.slice(-4)}
                              </div>
                              {account.iban && <div className="text-xs text-gray-400 mt-1" data-id="element-8463">
                                  IBAN: {account.iban}
                                </div>}
                              {account.swiftCode && <div className="text-xs text-gray-400" data-id="element-8464">
                                  SWIFT: {account.swiftCode}
                                </div>}
                            </div>
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" data-id="element-8465">
                            <div data-id="element-8466">
                              <div data-id="element-8467">{account.accountType}</div>
                              <div className="text-gray-400" data-id="element-8468">
                                {account.currency}
                              </div>
                            </div>
                          </td>
                          <td className="px-3 py-4 text-sm text-gray-500" data-id="element-8469">
                            <div className="flex flex-wrap gap-1" data-id="element-8470">
                              {account.association ? <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${getAssociationColor(account.association.type)}`} data-id="element-8471">
                                  {getAssociationIcon(account.association.type)}
                                  {account.association.name}
                                </span> : <span className="text-gray-400 italic" data-id="element-8472">
                                  Unused
                                </span>}
                            </div>
                          </td>
                          <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6" data-id="element-8473">
                            <div className="flex justify-end gap-2" data-id="element-8474">
                              <button type="button" onClick={e => handleEdit(account, e)} className="text-indigo-600 hover:text-indigo-900" data-id="element-8475">
                                <EditIcon className="h-4 w-4" data-id="element-8476" />
                                <span className="sr-only" data-id="element-8477">
                                  Edit, {account.accountName}
                                </span>
                              </button>
                              <button type="button" onClick={e => handleView(account, e)} className="text-green-600 hover:text-green-900" data-id="element-8478">
                                <EyeIcon className="h-4 w-4" data-id="element-8479" />
                                <span className="sr-only" data-id="element-8480">
                                  View, {account.accountName}
                                </span>
                              </button>
                              <button type="button" onClick={() => handleDelete(account.id)} className="text-red-600 hover:text-red-900" data-id="element-8481">
                                <TrashIcon className="h-4 w-4" data-id="element-8482" />
                                <span className="sr-only" data-id="element-8483">
                                  Delete, {account.accountName}
                                </span>
                              </button>
                            </div>
                          </td>
                        </tr>) : <tr data-id="element-8484">
                        <td colSpan={5} className="py-8 text-center text-sm text-gray-500" data-id="element-8485">
                          No bank accounts found matching your criteria.
                        </td>
                      </tr>}
                  </tbody>
                </table>

                {/* Pagination */}
                {totalPages > 1 && <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" data-id="element-8486">
                    <div className="flex-1 flex justify-between sm:hidden" data-id="element-8487">
                      <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-8488">
                        Previous
                      </button>
                      <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-8489">
                        Next
                      </button>
                    </div>
                    <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-8490">
                      <div data-id="element-8491">
                        <p className="text-sm text-gray-700" data-id="element-8492">
                          Showing{' '}
                          <span className="font-medium" data-id="element-8493">{startIndex + 1}</span>{' '}
                          to{' '}
                          <span className="font-medium" data-id="element-8494">
                            {Math.min(endIndex, totalItems)}
                          </span>{' '}
                          of <span className="font-medium" data-id="element-8495">{totalItems}</span>{' '}
                          results
                        </p>
                      </div>
                      <div data-id="element-8496">
                        <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-8497">
                          <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-8498">
                            <span className="sr-only" data-id="element-8499">Previous</span>
                            <ChevronLeftIcon className="h-5 w-5" data-id="element-8500" />
                          </button>
                          {[...Array(totalPages)].map((_, idx) => {
                      const page = idx + 1;
                      if (page === 1 || page === totalPages || page >= currentPage - 1 && page <= currentPage + 1) {
                        return <button key={page} onClick={() => handlePageChange(page)} className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${page === currentPage ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600' : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'}`} data-id="element-8501">
                                  {page}
                                </button>;
                      } else if (page === currentPage - 2 || page === currentPage + 2) {
                        return <span key={page} className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700" data-id="element-8502">
                                  ...
                                </span>;
                      }
                      return null;
                    })}
                          <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-8503">
                            <span className="sr-only" data-id="element-8504">Next</span>
                            <ChevronRightIcon className="h-5 w-5" data-id="element-8505" />
                          </button>
                        </nav>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>

            {/* Account Details Panel */}
            {viewingAccount && <div className="w-full lg:w-1/3 bg-white shadow rounded-lg border border-gray-200 p-6 h-fit sticky top-6" data-id="element-8506">
                <div className="flex justify-between items-start mb-6" data-id="element-8507">
                  <div className="flex items-center" data-id="element-8508">
                    <div className="h-12 w-12 rounded-full bg-indigo-100 flex items-center justify-center mr-4" data-id="element-8509">
                      <CreditCardIcon className="h-6 w-6 text-indigo-600" data-id="element-8510" />
                    </div>
                    <div data-id="element-8511">
                      <h2 className="text-xl font-bold text-gray-900" data-id="element-8512">
                        {viewingAccount.bankName}
                      </h2>
                      <p className="text-sm text-gray-500" data-id="element-8513">
                        {viewingAccount.accountName}
                      </p>
                    </div>
                  </div>
                  <button onClick={() => setViewingAccount(null)} className="text-gray-400 hover:text-gray-500" data-id="element-8514">
                    <XIcon className="h-5 w-5" data-id="element-8515" />
                  </button>
                </div>

                <div className="space-y-6" data-id="element-8516">
                  <div data-id="element-8517">
                    <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-3" data-id="element-8518">
                      Account Details
                    </h3>
                    <div className="space-y-3" data-id="element-8519">
                      <div className="flex justify-between text-sm" data-id="element-8520">
                        <span className="text-gray-500" data-id="element-8521">Account Number</span>
                        <span className="font-mono text-gray-900" data-id="element-8522">
                          •••• {viewingAccount.accountNumber.slice(-4)}
                        </span>
                      </div>
                      {viewingAccount.routingNumber && <div className="flex justify-between text-sm" data-id="element-8523">
                          <span className="text-gray-500" data-id="element-8524">Routing Number</span>
                          <span className="font-mono text-gray-900" data-id="element-8525">
                            {viewingAccount.routingNumber}
                          </span>
                        </div>}
                      {viewingAccount.swiftCode && <div className="flex justify-between text-sm" data-id="element-8526">
                          <span className="text-gray-500" data-id="element-8527">SWIFT Code</span>
                          <span className="font-mono text-gray-900" data-id="element-8528">
                            {viewingAccount.swiftCode}
                          </span>
                        </div>}
                      {viewingAccount.iban && <div className="flex justify-between text-sm" data-id="element-8529">
                          <span className="text-gray-500" data-id="element-8530">IBAN</span>
                          <span className="font-mono text-gray-900 break-all" data-id="element-8531">
                            {viewingAccount.iban}
                          </span>
                        </div>}
                      <div className="flex justify-between text-sm" data-id="element-8532">
                        <span className="text-gray-500" data-id="element-8533">Account Type</span>
                        <span className="text-gray-900" data-id="element-8534">
                          {viewingAccount.accountType}
                        </span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-8535">
                        <span className="text-gray-500" data-id="element-8536">Currency</span>
                        <span className="text-gray-900" data-id="element-8537">
                          {viewingAccount.currency}
                        </span>
                      </div>
                      {viewingAccount.branchName && <div className="flex justify-between text-sm" data-id="element-8538">
                          <span className="text-gray-500" data-id="element-8539">Branch</span>
                          <span className="text-gray-900" data-id="element-8540">
                            {viewingAccount.branchName}
                          </span>
                        </div>}
                      <div className="flex items-center text-sm pt-2" data-id="element-8541">
                        <CheckIcon className={`h-5 w-5 mr-3 ${viewingAccount.isPrimary ? 'text-green-500' : 'text-gray-300'}`} data-id="element-8542" />
                        <span className={viewingAccount.isPrimary ? 'text-gray-900 font-medium' : 'text-gray-500'} data-id="element-8543">
                          {viewingAccount.isPrimary ? 'Primary Account' : 'Secondary Account'}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="border-t border-gray-200 pt-6" data-id="element-8544">
                    <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-3" data-id="element-8545">
                      Used In
                    </h3>
                    {viewingAccount.association ? <div className="py-3 flex items-center justify-between" data-id="element-8546">
                        <div className="flex items-center" data-id="element-8547">
                          <span className={`inline-flex items-center justify-center h-8 w-8 rounded-full mr-3 ${getAssociationColor(viewingAccount.association.type)} bg-opacity-20`} data-id="element-8548">
                            {getAssociationIcon(viewingAccount.association.type)}
                          </span>
                          <div data-id="element-8549">
                            <p className="text-sm font-medium text-gray-900" data-id="element-8550">
                              {viewingAccount.association.name}
                            </p>
                            <p className="text-xs text-gray-500" data-id="element-8551">
                              {viewingAccount.association.type}
                            </p>
                          </div>
                        </div>
                        <button className="text-xs text-indigo-600 hover:text-indigo-900 font-medium" data-id="element-8552">
                          View
                        </button>
                      </div> : <p className="text-sm text-gray-500 italic" data-id="element-8553">
                        This account is not currently associated with any
                        record.
                      </p>}
                  </div>

                  <div className="border-t border-gray-200 pt-6 flex justify-end gap-3" data-id="element-8554">
                    <button onClick={e => handleEdit(viewingAccount, e)} className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-8555">
                      <EditIcon className="h-4 w-4 mr-2" data-id="element-8556" />
                      Edit
                    </button>
                    <button onClick={() => handleDelete(viewingAccount.id)} className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-8557">
                      <TrashIcon className="h-4 w-4 mr-2" data-id="element-8558" />
                      Delete
                    </button>
                  </div>
                </div>
              </div>}
          </div>
        </>}

      {view === 'form' && <div className="bg-white shadow sm:rounded-lg" data-id="element-8559">
          <div className="px-4 py-5 sm:p-6" data-id="element-8560">
            <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4" data-id="element-8561">
              {selectedAccount ? 'Edit Bank Account' : 'New Bank Account'}
            </h3>
            <BankAccountForm bankAccount={selectedAccount} onSave={handleSave} onCancel={handleCancel} locale={locale} data-id="element-8562" />
          </div>
        </div>}
    </div>;
}